module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAENSURBVCiRjdI/S0JhFMfx79GLJUQ12uZWGYFGQ+MzNAg1BLn0KsqhoXch9RriNkQQDb2CoKD8szzz3XTTq4J5B09DKHn1PnSmM3z4cfhxBMcYY7xuOLgTKIsL9cKBD1RQrpfCeaTVZrNeW4DLEID8BwGkp0s+n19F0vfAmU70stWq3/4N8QAKhcJaJpN9BY4EuWi2vh7jJ8kMyS9qND4XEICXWcm+TJOSEEAKNLHLORiNv09RPhT1S6XDSiK01g6jaFQGfXPhFIC1dri5sX6s6LOifrF4cBWHsx6DIJjs7mw/jcbjfRGp5nJbYafTfl+AMbwXx3PQhZ1v1g37D4KcK9w4OzTGeL1ev4bIyQ9W35A4JM11OwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/leftRun.png
// module id = jrAd
// module chunks = 1